import { render, staticRenderFns } from "./EquipPointDetailBtn.vue?vue&type=template&id=29946b42"
import script from "./EquipPointDetailBtn.vue?vue&type=script&lang=js"
export * from "./EquipPointDetailBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports